// extracted by mini-css-extract-plugin
export default {"c_header1":"CHeader_c_header1__aE7KW","c_header2":"CHeader_c_header2__D7uB6","c_header3":"CHeader_c_header3__qhSPL"};